import { Component, OnInit, ViewChild } from '@angular/core';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { urls } from '../../common/model/properties';
//import { ISubscription } from 'rxjs/Subscription';
import { SecureStorageService } from '../../secure-storage.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, RequiredValidator, Validators } from '@angular/forms';
import { PatientSurveyResultService } from './patient-survey-result.service';
import { HttpHeaders } from '@angular/common/http';
//import { saveAs } from "file-saver/FileSaver";
import { saveAs } from "file-saver";
import{Modal} from "bootstrap"



@Component({
    selector: 'app-patient-survey-result',
    templateUrl: './patient-survey-result.component.html',
    styleUrls: ['./patient-survey-result.component.scss'],
    standalone: false
})
export class PatientSurveyResultComponent implements OnInit {

  data = [];
  sites: any[];
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  showSpinner = false;
  showView: boolean;
  //loadProviderAffiliationSubscription: ISubscription;
  public providerAffiliationList: any[];
  providers: any[] = [];
  groupAffiliations: any[] = [{}];
  groupErrorMsg:boolean = false;
  pcpAllSites = [];
  showProviders = false;
  vendorCheck:boolean = true;
  vendorCheck1:boolean = true;
  public dataUpdateForm: UntypedFormGroup;

  selectedSite: any;
  selectedSA: any;
  selectedGA: any;
  selectedProviderModel: any;
  pcpDropdownforDCE: boolean= false;
  isReadOnly:any;
  documentType: any[] = [];
  surveyCreatedBy: any[] = [];
  statusType: any[] = [];
  spocType:any[] = [];
  selectData: any[] = [];
  selectValue: any[] = [];
  spocDetails: any[] = [];
  contactdetails : any[] = [];
  nameDetails: any[] = [];
  emailDetails: any[]= [];
  contactNumDetails: any[] = [];
  patientHistory: any[] = [];
  patientFile: any;
  submitted = false;
  ppUsername:any;
  clearSA = false;
  clearGA = false;
  files: any[] = [];
  attachmentForm: UntypedFormGroup;
  selectedDocumentsList: any[] = [];
  fileNotUploaded: boolean = false;
  filterData: any[] = [];
  p: any;
  siteIDData : any[] = [];
  newsiteID : any[] = [];

  startDateCal: any[] = [];
  endDateCal: any[] = [];

  MAX_FILE_SIZE = 26214400; //25*1024*1024 -- 25MB

  message: string;

  constructor(
    private cupService: CupService,
    private urlconstantsService: UrlconstantsService,
    private secureStorage:SecureStorageService,
    private fb: UntypedFormBuilder,
    private patientSurveyService: PatientSurveyResultService
  ) { 
    this.createDataUpdateForm();
  }

  handleResults(searchObj) {
    this.data = searchObj;
  }

  ngOnInit() {
    this.getExternalDashboard();
    //this.loadGroup();
    this.getPCPProviders();
    this.getDropDownListOptions();
    // this.newsiteID = this.siteIDData
    // //console.log("this.newsiteID--",this.newsiteID)
    //this.getPatientSurveyDetails(this.newsiteID);
    
  }

  setProviders(e) {
    ////console.log("e---:",e)
    this.selectedSA = e;
    if(e.id) {
      this.getGroupAffiliations(e.id);
    }


  }

  onProvidersSubmit(e) {
    ////console.log("onProvidersSubmit ---- :",e)
    this.selectedGA = e;
  }

  onFilechange(event) {
    this.patientFile = '';
    this.patientFile = event.target.files[0];
  }

  search(term: string) {
    if(!term) {
      this.filterData = this.patientHistory;
    } else {
      this.filterData = this.patientHistory.filter(x => 
         x.groupAffiliationName.trim().toLowerCase().includes(term.trim().toLowerCase())
      );
    }
  }

  upload(file) {
    this.showSpinner = true;
    ////console.log("file for upload---:",file);
    if(file.size > this.MAX_FILE_SIZE) {
      alert("Maximum File size should be 25MB");
      this.showSpinner = false;
      return;
    }
    let kvpl = [];
    kvpl = [
      // "documentName": this.patientFile,
      // "surveyCreatedBy": this.dataUpdateForm.value.surveyCreateFormControl,
      // "vendorName": this.dataUpdateForm.value.vendorNameFormControl ?this.dataUpdateForm.value.vendorNameFormControl : "",
      // "submissionStatus": this.dataUpdateForm.value.statusFormControl,
      // "startDate": this.dataUpdateForm.value.startDateFormControl ? this.formatDate(this.dataUpdateForm.value.startDateFormControl) : "",
      // "endDate": this.dataUpdateForm.value.endDateFormControl ? this.formatDate(this.dataUpdateForm.value.endDateFormControl) : "",
      {key: "Username", value: this.ppUsername},
      {key: "ProviderName", value:""},
      {key: "SiteName", value: this.selectedSA ? this.selectedSA.value : ""},
      {key: "GroupAffiliationName", value:this.selectedGA ? this.selectedGA.value : ""},
      {key: "DocumentType", value: this.dataUpdateForm.value.documentTypeFormControl ? this.dataUpdateForm.value.documentTypeFormControl : ""},
      {key: "providerNotes", value: this.dataUpdateForm.value.additionalNotesFormControl ? this.dataUpdateForm.value.additionalNotesFormControl : ""},
      //{key: "contactdetails", value: this.contactdetails},      
      {key: "UploadDate", value: this.currentDate()},
      {key: "DocumentReviewDate" , value: ""},
      {key: "ReviewedBy" , value: ""},
      {key: "DecisionStatus" , value: ""},
      {key: "PatientExperienceNotes" , value: ""},
      {key: "ApprovalFlag" , value: ""},
      {key: "SurveyPointofContact" , value: ""},
      {key: "SurveyPointofContactEmail" , value: ""},
      {key: "SurveyPointofContactPhone" , value: ""},
    ]

    this.patientSurveyService.uploadFile(file,kvpl).subscribe(
      (resp) => {  
        
        const parseResp= JSON.parse(resp);
        let response = <any>parseResp ;       
         let obj = { name: file.name, docId: response.docId };
        this.selectedDocumentsList.push(obj);
        file.docID = response.docId;
        this.showSpinner = false;
      }, err => { 
        this.showSpinner = false; 
        // jQuery('#docErrorModal').modal('show');
        this.openModal('docErrorModal');
      });
  }

  openModal(modalId:any){
    const modal=new Modal(document.getElementById(modalId));
    modal.show();
  }
  getUploadedDocument(docContent) {
    this.showSpinner = true;
    this.patientSurveyService
    .getDocument(docContent, null)
    .subscribe((res) => {
      ////console.log("res---:",res)
      const responseData = res;
      if (navigator.appVersion.toString().indexOf(".NET") > 0) {
        const blob = this.binary64ToBlob(
          responseData.docContent,
          responseData.fileType,
          512
        );
        saveAs(blob, responseData.filename);
        this.showSpinner = false;
      } else {
        const blob = this.b64toBlob(
          responseData.docContent,
          responseData.fileType,
          512
        );
        //const urlBlob = URL.createObjectURL(blob);
        saveAs(blob, responseData.filename);
        // window.open(urlBlob, "_blank", "location=yes,height=570,width=520");
        this.showSpinner = false;
      }
    });

  }

  binary64ToBlob(binary64String, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(binary64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  formatDate(date: any) {
    if(!date)
      return '';
    date = date.replace(/-+/g, '-');
    var array = (date || '').toString().split(/\-/g);
    let dateFormat = array[1]+ '/' + array[2] + '/' + array[0];
    return dateFormat;
  };

  currentDate() {
    const currentdate = new Date();
    const datetime = (currentdate.getMonth() + 1)+ '/' + currentdate.getDate() + '/' + currentdate.getFullYear();
    return datetime;
  }

  
  submitForm(e) {
    this.contactdetails = [];
    this.submitted = true;
    let attachmentRequest = [];
    this.fileNotUploaded = false;
    this.spocDetails = [];
    if(this.files) {       
      this.files.filter(file => {
        if(file.docID != '') {
          attachmentRequest.push({
            documentId: file.docID,
            fileName: file.name
          })
        }
        else {          
          this.fileNotUploaded = true;                  
        }
      });
    }
    ////console.log("attachmentRequest------:",attachmentRequest,this.fileNotUploaded);
    

    if(this.selectedSA == undefined) {
      alert("Please select Site");
      return;
    }

    if(this.selectedGA == undefined) {
      alert("Please select Group Affiliation");
      return;
    }

    if(this.fileNotUploaded) {
      alert("Please Upload the attached files");
      return;
    }

    if(attachmentRequest.length <= 0) {
      alert("Please Upload the Documents");
      return;
    }

    if(this.selectData && this.selectValue) {
      if(this.selectData.length == this.selectValue.length) {
        for (let i=0; i< this.selectData.length; i++) {
          this.spocDetails.push({"data":this.selectData[i].value,
          "value":this.selectValue[i].value});
        }
      }
      else {
        alert("Data missing in 'Survey Point Of Contact' field ");
        return; 
      }

    }

    this.spocDetails.forEach(o => {
      if(o.data == 'Name') {
        this.nameDetails.push(o.value)
        this.contactdetails.push({
          id: 1,
          type : o.value
        })
      }
      if(o.data =='Email') {
        this.emailDetails.push(o.value)
        this.contactdetails.push({
          id: 2,
          type : o.value
        })
      }
      if(o.data == 'Contact Number') {
        this.contactNumDetails.push(o.value)
        this.contactdetails.push({
          id: 3,
          type : o.value
        })
      }
    });

    if(this.contactdetails.length > 0) {
      let emailExist = 0;
      ////console.log("this.selectData--:",this.selectData)
      this.selectData.filter(x => {
        if (x.value == 'Email') {
          emailExist = 1;          
        }
      })
      if (emailExist == 0) {
        alert("Please Enter Email from 'Survey Point Of Contact' field");
        return;
      }
     
    }    
    else {
      alert("Please Enter Email from 'Survey Point Of Contact' field");
      return;
    }

    let fileObj;

    fileObj = {
      "ppU_Name": this.ppUsername,
      "providerName": "",
      "attachmentRequest" : attachmentRequest,
      "siteName": this.selectedSA.value,
      "siteUid":this.selectedSA.id,
      "groupAffiliationName" : this.selectedGA.value,
      "documentType":this.dataUpdateForm.value.documentTypeFormControl,
      "surveyCreatedBy": this.dataUpdateForm.value.surveyCreateFormControl,
      "vendorName": this.dataUpdateForm.value.vendorNameFormControl ?this.dataUpdateForm.value.vendorNameFormControl : "",
      "submissionStatus": this.dataUpdateForm.value.statusFormControl,
      "startDate": this.dataUpdateForm.value.startDateFormControl ? this.formatDate(this.dataUpdateForm.value.startDateFormControl) : "",
      "endDate": this.dataUpdateForm.value.endDateFormControl ? this.formatDate(this.dataUpdateForm.value.endDateFormControl) : "",
      "providerNotes": this.dataUpdateForm.value.additionalNotesFormControl ? this.dataUpdateForm.value.additionalNotesFormControl : "",
      "contactdetails" : this.contactdetails,
      "uploadedDate": this.currentDate(),

    }

    if (this.dataUpdateForm.invalid) {
      const element = document.getElementById("mainContainerDiv");
      element.scrollTo(0,0);
      return;
  } 

  if (this.attachmentForm.invalid) {
    const element = document.getElementById("attachmentCont");
    element.scrollTo(0,0);
    return;
  } 

 
    this.showSpinner = true;
    this.patientSurveyService.saveDetails(fileObj).subscribe({
      next: (resp) => {
        this.showSpinner = false;
        let response :any= resp;
      // //console.log("PDM Data File upload response:",response, response.status);
      if(response.status == 200) {
        alert("Patient survey Data submitted successfully .");
        this.clearForm();
        //this.attachmentForm.get('attachmentControl').reset();
        this.getPatientSurveyDetails(this.siteIDData);
        this.filterData = this.patientHistory
        }
        else {
          alert("Something went wrong, please submit again! ");
        }
      },
      error: (err) => {
        this.showSpinner = false;
        console.error('Error submitting patient survey:', err);
        alert("Something went wrong, please submit again! ");
      }
    })
  }


  clearForm(){
    this.clearSA = true;
    this.clearGA = true;
    this.submitted = false;
    this.dataUpdateForm.reset();
    this.attachmentForm.reset();
    this.files = [];
    this.selectedSite = '';
    this.selectedProviderModel = '';
    this.selectedSA = undefined;
    this.selectedGA = undefined;
    this.dataUpdateForm.controls.vendorNameFormControl.disable()
    this.dataUpdateForm.controls.vendorNameFormControl.reset()
    this.dataUpdateForm.controls.vendorNameFormControl.clearValidators();
    this.dataUpdateForm.controls.vendorNameFormControl.updateValueAndValidity();
    this.dataUpdateForm.controls.startDateFormControl.disable()
    this.dataUpdateForm.controls.endDateFormControl.disable()
    this.dataUpdateForm.controls.startDateFormControl.reset()
    this.dataUpdateForm.controls.endDateFormControl.reset()
    this.dataUpdateForm.controls.startDateFormControl.clearValidators();
    this.dataUpdateForm.controls.startDateFormControl.updateValueAndValidity();
    this.dataUpdateForm.controls.endDateFormControl.clearValidators();
    this.dataUpdateForm.controls.endDateFormControl.updateValueAndValidity(); 

    if(this.spocDetails.length > 0) {      
      for(let i=1; i<=this.spocDetails.length;i++) {
        this.removeTime(0);
      }
    }   
  }

  get documentTypeFormControl() {
    return this.dataUpdateForm.get('documentTypeFormControl');
  } 
  
  get surveyCreateFormControl() {
    return this.dataUpdateForm.get('surveyCreateFormControl');
  } 

  get statusFormControl() {
    return this.dataUpdateForm.get('statusFormControl');
  }  

  // get uploadDocument() {
  //   return this.dataUpdateForm.get('uploadDocument');
  // } 

  get attachmentControl() {
    return this.attachmentForm.get('attachmentControl');
  }

  get startDateFormControl() {
    return this.dataUpdateForm.get('startDateFormControl');
  }
  get endDateFormControl() {
    return this.dataUpdateForm.get('endDateFormControl');
  }

  get vendorNameFormControl() {
    return this.dataUpdateForm.get('vendorNameFormControl');
  }

  getExternalDashboard() {
    this.sites = []; 
    this.siteIDData = [];
    //this.pcpscorecard = false;   
    const username = this.cupService.getUserNameFromJWT();
    this.ppUsername = username;
    const url = this.urlConstant.providerDashboard ;    
    this.showSpinner = true;
    this.cupService.retrieveData('post', url).subscribe(
      data => {
        if (data != null) {
          // this.sites = data.sites;
          if (data.sites && data.sites.length) {
            data.sites.map(element => {
              this.sites.push({
                'id': element.siteUid,
                'value': element.siteName,
                'label': element.siteName
              })
              this.siteIDData.push(element.siteUid);
            });
          }
          this.showView = true;
          this.getPatientSurveyDetails(this.siteIDData);
          this.filterData = this.patientHistory
        }
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  private createDataUpdateForm() {
    this.dataUpdateForm = this.fb.group({
      documentTypeFormControl: ['',[Validators.required]],
      surveyCreateFormControl: ['',[Validators.required]],
      vendorNameFormControl: [{value: '', disabled: true}],
      statusFormControl: ['',[Validators.required]],
      startDateFormControl: [{value: '', disabled: true}],
      endDateFormControl: [{value: '', disabled: true}],
      additionalNotesFormControl: [''],
      //uploadDocument: ['',[Validators.required]],
     
      timecheck: this.fb.array([
        this.fb.group ({
          dataControl: [''],
          valueControl: [''],
          // phoneNumberFormControl: [''],
        })
      ])
    });

    this.attachmentForm = new UntypedFormGroup({
      attachmentControl: new UntypedFormControl('',[Validators.required])
    });
}

get timecheck() : UntypedFormArray {
  return this.dataUpdateForm.get("timecheck") as UntypedFormArray
}

newTime(): UntypedFormGroup {
  return this.fb.group({
    dataControl: [''],
    valueControl: [''],
    // phoneNumberFormControl: [''],
  })
}


onSelectionDay(event,ind){
  if (this.selectData.length > 0 ) {
    if(this.selectData.length == ind) {
      this.selectData.push({
        index:ind,
        value:event.target.value
      })
     }
     else {    
      this.selectData[ind].value = event.target.value
     }   
  }
  else {
    this.selectData.push({
      index:ind,
      value:event.target.value
    })
  }
  ////console.log("this.selectData--:",this.selectData);
}

validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

onSelectionValue(event,ind) { 
  //console.log("this.selectData----:",this.selectData[ind].value);
  //console.log("this.selectValue----:",this.selectValue);
  if(this.selectData) {
    if (this.selectData[ind].value == 'Email') {
      let eventValue = event.target.value;
      if(!this.validateEmail(eventValue)) {
        alert("Please enter valid Email address")
        event.target.value = '';
        return false;
      }
    }
    if (this.selectData[ind].value == 'Contact Number') { 
      //console.log("contact num--")
      const pattern = /[0-9\+\-\ ]/;
    //let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(event.target.value)) {
      // invalid character, prevent input
      //event.preventDefault();
      alert("Please enter Numbers")
      event.target.value = '';
      return false;
    }

    }

  }

  if (this.selectValue.length > 0) {  
  if(this.selectValue.length == ind) {
    this.selectValue.push({
      index:ind,
      value:event.target.value
    })
   }
   else {    
    this.selectValue[ind].value = event.target.value
   }
  }
  else {
    this.selectValue.push({
      index:ind,
      value:event.target.value
    })
  }

  ////console.log("this.selectValue----:",this.selectValue);
}

addTime() {      
  this.timecheck.push(this.newTime());      
}

removeTime(i:number) {
  this.timecheck.removeAt(i);  
  if (this.selectData) {
    if (i > -1) { 
      this.selectData.splice(i, 1); 
    }
  }
  if (this.selectValue) {
    if (i > -1) { 
      this.selectValue.splice(i, 1); 
    }
  }
}   



  getPCPProviders() {
    let userNameFromToken = this.cupService.getUserNameFromJWT();
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteProviders.replace(
      '{id}',
      userNameFromToken
    );
    setTimeout(() => {
      this.showSpinner = true;
    }, 100);
    let checkDuplicates = [];
    this.cupService.retrieveData('post', siteDetailURL).subscribe(
      siteData => {
        if (siteData && siteData.length) {
          ////console.log("getPCPProviders :",siteData);
          siteData.map(each => {
            if(each.providers && each.providers.length > 0){
            let providerIds = [];
            each.providers.map(element => {
              if (element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                element.value =
                  element.name +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                  element.region +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
                if (!providerIds.includes(element.providerId)) {
                  providerIds.push(element.providerId);
                }
              }
            });
            this.pcpAllSites.push({
              value: { id: each.siteUid, value: each.name },
              uid: providerIds
            });
          }
          });
        } else {
          //this.diseasesList = [];
        }
        this.showProviders = true;
        this.showSpinner = false;

      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  getGroupAffiliations(siteId?) {
    this.groupAffiliations = [];      

    this.patientSurveyService.getGroupAffiliationsDetails(siteId).subscribe(siteData => {
      let checkDuplicates = [];
      if(siteData) {        
        ////console.log("sites --",siteData)
          if (siteData && siteData.length) {
            siteData.map(each => {
              if(each){
                this.groupErrorMsg = false;
              let providerIds = [];
              each.map((element,index) => {   
                this.groupErrorMsg = true;
                if(element.name) {                 
                  if (!checkDuplicates.includes(element.name)) {
                    checkDuplicates.push(element.name)                     
                    this.groupAffiliations.push({id: index,
                      value:element.name})
                  }
              }
            })
          }
        });
      }        
    }  
    ////console.log(this.groupAffiliations.length)
    if (this.groupAffiliations.length <= 0) {
      alert("Selected site is not associated to any active group affiliations. Please reach out to Provider Relations for any additional information.");
    }
   
  })
 
 }


  loadGroup() {
    
    // const url = this.urlconstantsService.fetchUrl().getprovidersearchlist
    //   .replace('{type}', 'PROVIDERAFFILIATION')
    //   .replace('{keyword}', '');
     this.cupService.retrieveData('get', urls.providerAffiliation).subscribe(datagrp => {
      //sessionStorage.setItem('GroupList', JSON.stringify(datagrp.providerSearchListResponse));
      this.providerAffiliationList = datagrp;


    })
  }

  changetextbox(event) {
    ////console.log("event---:",event.target.value)
    if(event.target.value != 1 ) {
      this.vendorCheck = false;
      this.dataUpdateForm.controls.vendorNameFormControl.enable()
      this.dataUpdateForm.controls.vendorNameFormControl.setValidators([Validators.required])
      this.dataUpdateForm.controls.vendorNameFormControl.updateValueAndValidity();
    } else {
      this.vendorCheck = true;
      this.dataUpdateForm.controls.vendorNameFormControl.disable()
      this.dataUpdateForm.controls.vendorNameFormControl.reset();
      this.dataUpdateForm.controls.vendorNameFormControl.clearValidators();
      this.dataUpdateForm.controls.vendorNameFormControl.updateValueAndValidity();
    }
  }

  changeStatus(event) {
    ////console.log("event---:",event.target.value)
    if(event.target.value != 2) {
      this.vendorCheck1 = false;
      this.dataUpdateForm.controls.startDateFormControl.enable()
      this.dataUpdateForm.controls.endDateFormControl.enable()
      this.dataUpdateForm.controls.startDateFormControl.setValidators([Validators.required])
      this.dataUpdateForm.controls.startDateFormControl.updateValueAndValidity();
      this.dataUpdateForm.controls.endDateFormControl.setValidators([Validators.required])
      this.dataUpdateForm.controls.endDateFormControl.updateValueAndValidity();

    } else {
      this.vendorCheck1 = true;
      this.dataUpdateForm.controls.startDateFormControl.disable()
      this.dataUpdateForm.controls.endDateFormControl.disable()
      this.dataUpdateForm.controls.startDateFormControl.reset()
      this.dataUpdateForm.controls.endDateFormControl.reset()
      this.dataUpdateForm.controls.startDateFormControl.clearValidators();
      this.dataUpdateForm.controls.startDateFormControl.updateValueAndValidity();
      this.dataUpdateForm.controls.endDateFormControl.clearValidators();
      this.dataUpdateForm.controls.endDateFormControl.updateValueAndValidity();
    }

  }

  getDropDownListOptions() {
    this.documentType = [];
    this.surveyCreatedBy = [];
    this.statusType = [];
    this.spocType = [];
    let doctype = 'DOCUMENTTYPE';
    let spoc = 'SURVEYPOINTOFCONTACTTYPE';
    let surveyby = 'SURVEYCREATEDBY';
    let statustype= 'SURVEYSTATUSTYPE';

    this.patientSurveyService.getDropDownList(doctype).subscribe(data => {
      if(data) {
        if(data.patientExperienceDropDownsResponse.length > 0) {          
          this.documentType.push(data.patientExperienceDropDownsResponse);
        }
      }
    })

    this.patientSurveyService.getDropDownList(spoc).subscribe(data => {
      if(data) {
        if(data.patientExperienceDropDownsResponse.length > 0) {
          this.spocType.push(data.patientExperienceDropDownsResponse);
        }
      }
    })

    this.patientSurveyService.getDropDownList(surveyby).subscribe(data => {
      if(data) {
        if(data.patientExperienceDropDownsResponse.length > 0) {
          this.surveyCreatedBy.push(data.patientExperienceDropDownsResponse);
        }
      }
    })

    this.patientSurveyService.getDropDownList(statustype).subscribe(data => {
      if(data) {
        if(data.patientExperienceDropDownsResponse.length > 0) {          
          this.statusType.push(data.patientExperienceDropDownsResponse);
        }
      }
    })

  }

  getPatientSurveyDetails(newsiteID?) {
    this.patientHistory = [];
         this.patientSurveyService.getPatientSurveyDetails(newsiteID).subscribe(data => {
      if(data) {
        let res:any;
        res= data;
        ////console.log("printing ompr data :",res)
        res.map((element, index) => {
          let obj: any = {};
            obj.approvalFlag = element.approvalFlag;
            obj.decisionStatus = element.decisionStatus;
            obj.documentName = element.documentName;
            obj.documentReviewDate = element.documentReviewDate;
            obj.documentType = element.documentType;
            obj.groupAffiliationName = element.groupAffiliationName;
            obj.patientExperienceNotes = element.patientExperienceNotes;
            obj.ppUsername = element.ppUsername;
             obj.providerName = element.providerName;
            obj.providerNotes = element.providerNotes;
            obj.reviewedBy = element.reviewedBy;
            obj.siteName = element.siteName;
            obj.submissionStatus = element.submissionStatus;
            obj.surveyCreatedBy = element.surveyCreatedBy;
            obj.patientExperienceNotes = element.patientExperienceNotes;
            obj.decisionStatus = element.decisionStatus;
            // obj.surveyPointofContactPhone = element.surveyPointofContactPhone;
            obj.uploadedDate = element.uploadedDate;
            obj.vendorName = element.vendorName;
            obj.startDate = element.startDate;
            obj.endDate = element.endDate;
            this.patientHistory.push(obj);          
        })
        ////console.log("patientHistory ----:",this.patientHistory)
          
      }
    })

  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  private showPopuup(message: string) {
    this.message = message;
    // jQuery('#alertModal').modal('show');
    this.openModal("alertModal");
    return;
}

  private isValidFileType(file) {
    const fileExtension=file.name.split('.').pop();
    if(fileExtension=== 'pdf' || fileExtension === 'docx' || fileExtension=== 'doc' || fileExtension=== 'xlsx' || fileExtension=== 'xls' || fileExtension=== 'ppt' || fileExtension=== 'pptx' || fileExtension==='jpg' || fileExtension==='jpeg' || fileExtension==='png') {      
      return true
    }

    return false;
  }

  private isSupportedFileType(fileType): boolean {
    // if(!event.target.files[0].type.match('.pdf') && !event.target.files[0].type.match('.docx')) {      
    if(fileType === 'application/pdf' || fileType === 'application/msword' ||
          fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || fileType === 'application/vnd.ms-excel' ||
          fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          fileType === 'image/jpg' || fileType === 'image/jpeg' || fileType === 'image/png') {      
      return true;
    }

    return false;
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  prepareFilesList(files: Array<any>) {
     for (const item of files) {
      if(!this.isSupportedFileType(item.type)){
        this.showPopuup("The file type is not valid. Permitted document types are Word (.doc, .docx), Excel (.xls, .xlsx), Picture (.jpg, .jpeg, .png ) and .PDF files");
        return;
      }else{
        if (!this.files.some(x => x.name === item.name)) {
          item.progress = 0;
          item.docID = "";
          this.files.push(item);
        }
    }}

    ////console.log("prepareFilesList files--:",files)
    // for (const item of files) {
    //   // //console.log('item ->' + JSON.stringify(item.name));
    //   if (!this.files.some(x => x.name === item.name)) {
    //     item.progress = 0;
    //     item.docID = "";
    //     this.files.push(item);
    //   }
    // }
    // this.uploadFilesSimulator(0);
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  deleteFile(index: number, file) {

    if (file.docID === '' || file.docID === null) {
      this.files.splice(index, 1);
      this.attachmentForm.get('attachmentControl').reset();
 
    } else {
      // this.confirmationService.confirm({
      //   message: 'Do you want to delete this document? Clicking on yes will delete this document permanently.',
      //   accept: () => { this.deleteDocument(index, file); },
      //   reject: () => { }
      // });
      let confirmAction = confirm("Do you want to delete this document? Clicking on yes will delete this document permanently.");
      if (confirmAction) {
        //alert("Action successfully executed");
        //this.deleteDocument(index, file);
        this.deleteDocument(file.docID);

      } else {
        //alert("Action canceled");
      }
    }
  }

  deleteDocument(docID) {    
    this.patientSurveyService.deleteuploadedDoc(docID).subscribe(docResponse => {
     let responseData :any = docResponse;       
    this.files = this.files.filter(file =>(responseData.docID !== file.docID));
    if(responseData && responseData.errCode == null) {                  
    }
    else {
      ////console.log("Error in uploading file:")  // check for error message.
    }

  });
}

onSelectionStartDate(event) {  
  this.startDateCal = [];
  this.startDateCal.push({value : event.target.value})
}

onSelectionEndDate(event) { 
  this.endDateCal = [];
  if(this.startDateCal.length <= 0) {
    alert('Please enter Start Date');
    this.dataUpdateForm.patchValue({
      'endDateFormControl':''
    }); 
  }
  this.endDateCal.push({value : event.target.value})
    
  if(this.startDateCal) {
    if (this.startDateCal[0].value >= this.endDateCal[0].value ) {
      alert('End Date should be greater then Start Date')
      this.dataUpdateForm.patchValue({
        'endDateFormControl':''
      });   
    }
  }
 
}

  // deleteDocument(index, file) {
  //   this.cupService.isShowSpinner(true);
  //   const userInfo = JSON.parse(sessionStorage.getItem('currentUser'));
  //   const ppjwt = JSON.parse(sessionStorage.currentUser);
  //   const headers = new HttpHeaders({
  //     'Authorization': 'Bearer ' + ppjwt.access_token
  //   });
  //   const options = { headers: headers };
  //   const url = this.urlconstantsService.fetchUrl().documentUrl + "/" + file.docID + "?appId=Rank&documentCode=PROV_DOC&deletedByUser=" + userInfo.uName;

  //   this.http.delete(url, options)
  //     .subscribe(
  //       (resp) => {
  //         const data = <any>resp;
  //         if (data.docID !== null && data.docID !== "") {
  //           this.deleteAttachment(index, file);
  //         } else {
  //           this.cupService.isShowSpinner(false);
  //         }
  //       }, err => { this.cupService.isShowSpinner(false); });
  // }

  // deleteAttachment(index, file) {
  //   // this.cupService.isShowSpinner(true);
  //   const userInfo = JSON.parse(sessionStorage.getItem('accessPermission'));
  //   let formData = {
  //     documentId: file.docID,
  //     fileName: file.name,
  //     providerInteractionUid: this.providerInteractionUid,
  //     userUid: userInfo.userId
  //   }
  //   // //console.log('form data ->' + json);
  //   const ppjwt = JSON.parse(sessionStorage.currentUser);
  //   const headers = new HttpHeaders({
  //     'Authorization': 'Bearer ' + ppjwt.access_token
  //   });
  //   var options = {
  //     headers: headers,
  //     body: formData
  //   };
  //   this.http.delete(this.urlconstantsService.fetchUrl().deleteAttachment, options)
  //     .subscribe(data => {
  //       if (data) {
  //         this.files.splice(index, 1);
  //         this.attachmentForm.get('attachmentControl').reset();
  //         this.cupService.isShowSpinner(false);
  //       }
  //       this.cupService.isShowSpinner(false);
  //     }, error => { this.cupService.isShowSpinner(false); });
  // }

}
